// extracted by mini-css-extract-plugin
export default {"item":"VideoGridItem_item__VtZSA"};